import { useEffect, useState } from "react";
import { css } from "@emotion/react";
import { TwitterTweetEmbed } from "react-twitter-embed";

const Twitter: React.FC = () => {
  const [isLoadwidgets, setIsLoadwidgets] = useState(false);

  useEffect(() => {
    if (!isLoadwidgets) {
      const s = document.createElement("script");
      s.setAttribute("src", "https://platform.twitter.com/widgets.js");
      document.body.appendChild(s);
      setIsLoadwidgets(true);
    }
  }, []);
  return (
    <div css={mainStyle} id="twitter">
      <div css={contentsWrapper}>
        <div css={upperTitleWrapperStyle}>
          <div css={borderStyle}></div>
          <div css={titleStyle}>公式Twitter</div>
          <div css={borderStyle}></div>
        </div>
        <div css={twitterContainer}>
          <div css={twitterWrapperStyle}>
            <TwitterTweetEmbed tweetId="1688145391391219712" />
          </div>
        </div>
        <div css={bottomBorderWrapperStyle}>
          <div css={borderStyle}></div>
        </div>
        <div css={iconButtonWrapperStyle}>
          <a
            href="https://twitter.com/ce_butai"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={process.env.REACT_APP_ASSET_BASE_PATH + "/img/twitter.png"}
              alt="twitter"
              width="30"
              height="36"
            />
          </a>
        </div>
      </div>
    </div>
  );
};

const primaryColor = "#DD6B74";

const mainStyle = css`
  width: 100%;
  margin-top: 20px;
  background-color: rgba(255, 255, 255);
  display: flex;
  justify-content: center;
`;

const contentsWrapper = css`
  width: 100%;
  max-width: 500px;
  padding: 30px 20px 10px;
`;

const twitterContainer = css`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const twitterWrapperStyle = css`
  z-index: 1;
  position: relative;
  width: 340px;
  height: 200px;
  overflow-y: scroll;
`;

const tweetStyle = css`
  width: 280px;
`;

const upperTitleWrapperStyle = css`
  display: flex;
  align-items: center;
`;

const bottomBorderWrapperStyle = css`
  padding-top: 10px;
  display: flex;
  align-items: center;
`;

const borderStyle = css`
  height: 1px;
  background-color: ${primaryColor};
  flex-grow: 1;
`;

const titleStyle = css`
  margin: 0 10px;
  font-size: 12pt;
  font-weight: 500;
`;

const iconButtonWrapperStyle = css`
  width: 100%;
  padding: 15px 0 5px;
  display: flex;
  justify-content: center;
`;

export default Twitter;
